// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2jTvQ","list":"styles_list__OQYJR"};